import React, { FC } from 'react'
import Pagination from 'components/SA/Pagination'
import { handleScrollToTop } from 'components/SA/Facets/helpers'
import SelectHitsPerPage from 'components/SA/Pagination/SelectHitsPerPage'
import { getHrefFunction, updateClientSideUrl } from 'components/SA/SearchProvider/helpers/url'
import { UseReduxSearchProviderResponse } from '../types'
import styles from '../SearchProvider.module.scss'
import useReduxSearchProvider from '../hooks/useReduxSearchProvider'

type SearchProviderPaginationProps = {
  pageNumber?: number
  hitsPerPage?: number
  totalResults?: number
  selectedCategory?: string
  baseUrl: string
  nextAppRoute: string
  isSelectHitsPerPageVisible?: boolean
  useReduxProviderHook?: () => UseReduxSearchProviderResponse
  isMobileStyle?: boolean
  notSlugifiedFacetNames?: ReadonlyArray<string>
}

type HandleChangePageParams = {
  page?: number
  resultsPerPage?: number
  totalResultsNumber?: number
}

const SearchProviderPagination: FC<SearchProviderPaginationProps> = ({
  pageNumber = 1,
  hitsPerPage = 100,
  totalResults = 0,
  baseUrl,
  nextAppRoute,
  isSelectHitsPerPageVisible = true,
  isMobileStyle = true,
  useReduxProviderHook = useReduxSearchProvider,
  notSlugifiedFacetNames = [],
}) => {
  const { selectedFacets, basicQueryParams, pathParams, sharedFacetNames } = useReduxProviderHook()

  const totalPages = Math.ceil(totalResults / hitsPerPage)

  const getHrefChangingPage = ({
    page = pageNumber,
    resultsPerPage = hitsPerPage,
  }: HandleChangePageParams): string => {
    return getHrefFunction({
      facetsAndQueryParams: {
        ...selectedFacets,
        ...basicQueryParams,
        page: [`${page}`],
        hitsPerPage: [`${resultsPerPage}`],
      },
      pathParams,
      sharedFacetNames,
      notSlugifiedFacetNames,
    })()
  }

  const handleChangeHitsPerPage = ({ value }) => {
    handleScrollToTop(() => {
      const href = getHrefChangingPage({
        page: 1,
        resultsPerPage: Number(value),
      })
      const newUrlPath = `${baseUrl}${href}`

      updateClientSideUrl(newUrlPath, nextAppRoute)
    })
  }

  const handleClickNewPage = ({ page }) => {
    handleScrollToTop(() => {
      const href = getHrefChangingPage({
        page,
      })
      const newUrlPath = `${baseUrl}${href}`

      updateClientSideUrl(newUrlPath, nextAppRoute)
    })
  }

  return (
    <div className={styles.searchProviderPaginationContainer}>
      <Pagination
        current={pageNumber}
        total={totalPages}
        onClickLink={handleClickNewPage}
        urlWithParam={getHrefChangingPage}
        isMobileStyle={isMobileStyle}
      />

      {totalResults !== 0 && isSelectHitsPerPageVisible && (
        <SelectHitsPerPage
          hitsPerPage={hitsPerPage}
          handleChangeHitsPerPage={handleChangeHitsPerPage}
        />
      )}
    </div>
  )
}

export default SearchProviderPagination
